import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { MaterialModule } from '../material/material.module';
import { GenericFieldComponent } from './component/generic-field/generic-field.component';
import { BooleanFieldComponent } from './component/boolean-field/boolean-field.component';
import { NumberFieldComponent } from './component/number-field/number-field.component';
import { DateFieldComponent } from './component/date-field/date-field.component';
import { TextFieldComponent } from './component/text-field/text-field.component';
import { LongTextFieldComponent } from './component/long-text-field/long-text-field.component';
import { ListFieldComponent } from './component/list-field/list-field.component';
import { FieldGroupComponent } from './component/field-group/field-group.component';
import { MaterialModule } from 'app/shared/material/material.module';

@NgModule({
  declarations: [
    GenericFieldComponent,
    BooleanFieldComponent,
    NumberFieldComponent,
    DateFieldComponent,
    TextFieldComponent,
    LongTextFieldComponent,
    ListFieldComponent,
    FieldGroupComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
  ],
  exports: [
    GenericFieldComponent,
    BooleanFieldComponent,
    NumberFieldComponent,
    DateFieldComponent,
    TextFieldComponent,
    LongTextFieldComponent,
    ListFieldComponent,
    FieldGroupComponent,
  ],
})
export class FieldModule {}
